module.exports = __webpack_public_path__ + "img/type_crafting@2x.41f88cea.png";